import script from "./SpecialtiesScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialtiesScreen.vue?vue&type=script&setup=true&lang=js"

import "./SpecialtiesScreen.vue?vue&type=style&index=0&id=1d602f06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d602f06"]])

export default __exports__